import { createAsyncThunk } from '@reduxjs/toolkit'
import { ErreurResponse, Pipeline } from '../../types/pipelineTypes'
import {
  addPipelineApi,
  deletePipelineApi,
  getAllPipelines,
  getPipelinebyIdApi,
  getPipelinebyMissionApi,
  updatePipelineApi,
} from '../../api/pipelineApi'
import { handleError } from '../../utils/errorHandler'

export const getPipelines = createAsyncThunk<
  {
    pipelines: Pipeline[]
    total: number
    totalPages: number
    status?: number
    erreur?: boolean
    message?: string
  },
  { search?: string; page?: number; pageSize?: number },
  { rejectValue: string }
>('pipeline/getAllPipelines', async ({ search, page, pageSize }, thunkAPI) => {
  try {
    const response = await getAllPipelines({ search, page, pageSize })
    return {
      pipelines: response.pipelines,
      total: response.total,
      totalPages: response.totalPages,
      status: response.status,
      message: response.message,
      erreur: response.erreur,
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const deletePipeline = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('pipeline/deletePipeline', async (AuditId, thunkAPI) => {
  try {
    await deletePipelineApi(AuditId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addPipeline = createAsyncThunk<
  Pipeline,
  Pipeline,
  { rejectValue: ErreurResponse }
>('pipeline/addPipeline', async (newPipeline, thunkAPI) => {
  try {
    const response = await addPipelineApi(newPipeline)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error as ErreurResponse)
  }
})
export const getPipelinebyId = createAsyncThunk<
  Pipeline,
  string,
  { rejectValue: string }
>('pipeline/getPipelinebyId', async (PipelineId, thunkAPI) => {
  try {
    const response = await getPipelinebyIdApi(PipelineId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updatePipeline = createAsyncThunk<
  Pipeline,
  { updatedPipeline: Pipeline; _id: string },
  { rejectValue: string }
>('pipeline/updatePipeline', async ({ updatedPipeline, _id }, thunkAPI) => {
  try {
    const response = await updatePipelineApi(updatedPipeline, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getPipelinebyMission = createAsyncThunk<
  { pipelines: Pipeline[]; total: number; totalPages: number },
  { page?: number; pageSize?: number; MissionId: string },
  { rejectValue: string }
>(
  'pipeline/getPipelinebyMissionId',
  async ({ page, pageSize, MissionId }, thunkAPI) => {
    try {
      const response = await getPipelinebyMissionApi(MissionId, page, pageSize)
      return {
        pipelines: response.pipelines,
        total: response.total,
        totalPages: response.totalPages,
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
